// src/pages/Contact.js
import CmsPage from "../components/pages/CmsPage";

export default function Contact() {
  return (
    <CmsPage
      slug="contact"
      fallbackTitleAr="تواصل معنا"
      fallbackTitleEn="Contact Us"
      fallbackContentAr="<p>يسعدنا تواصلك معنا دائماً! فريق الدعم الفني وخدمة العملاء متواجد لمساعدتك والإجابة على كافة استفساراتك على مدار الساعة:</p><ul><li><strong>البريد الإلكتروني:</strong> support@mousagroup.net</li><li><strong>الهاتف:</strong> +1 (307) 998-8849</li><li><strong>العنوان البريدي:</strong> 30 N Gould St, Sheridan, WY 82801, USA</li><li><strong>ساعات العمل:</strong> من الأحد إلى الخميس (9:00 صباحاً - 6:00 مساءً)</li></ul>"
      fallbackContentEn="<p>We are always delighted to hear from you! Our support team is available 24/7 to assist you:</p><ul><li><strong>Email:</strong> support@mousagroup.net</li><li><strong>Phone:</strong> +1 (307) 998-8849</li><li><strong>Address:</strong> 30 N Gould St, Sheridan, WY 82801, USA</li><li><strong>Working Hours:</strong> Sunday to Thursday (9:00 AM - 6:00 PM)</li></ul>"
    />
  );
}
